import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IReviewsResponse, IMoveReviewResponse, TReviewPayload } from './types';

export const reviewsService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить отзывы
     */
    getReviews: builder.query<UnwrapData<IReviewsResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}/reviews`,
      }),
      transformResponse: (response: IReviewsResponse): UnwrapData<IReviewsResponse> => response.data,
      providesTags: ['MainPageReviews'],
    }),
    /**
     * Создать отзыв
     */
    createReview: builder.mutation<UnwrapData<IReviewsResponse>, { id: number; data: TReviewPayload }>({
      query: ({ id, data }) => ({
        method: 'POST',
        url: `/main_pages/${id}/reviews`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IReviewsResponse): UnwrapData<IReviewsResponse> => response.data,
      invalidatesTags: ['MainPage', 'MainPageReviews'],
    }),
    /**
     * Изменить отзыв
     */
    updateReview: builder.mutation<
      UnwrapData<IReviewsResponse>,
      { mainPageId: number; reviewId: number; data: TReviewPayload }
    >({
      query: ({ mainPageId, reviewId, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${mainPageId}/reviews/${reviewId}`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IReviewsResponse): UnwrapData<IReviewsResponse> => response.data,
      invalidatesTags: ['MainPageReviews'],
    }),
    /**
     * Удалить отзыв
     */
    deleteReview: builder.mutation<void, { mainPageId: number; reviewId: number }>({
      query: ({ mainPageId, reviewId }) => ({
        method: 'DELETE',
        url: `/main_pages/${mainPageId}/reviews/${reviewId}`,
      }),
      invalidatesTags: ['MainPage', 'MainPageReviews'],
    }),
    /**
     * Изменить позицию отзыва
     */
    moveReview: builder.mutation<
      UnwrapData<IMoveReviewResponse>,
      { mainPageId: number; reviewId: number; position: number }
    >({
      query: ({ mainPageId, reviewId, position }) => ({
        method: 'POST',
        url: `/main_pages/${mainPageId}/reviews/${reviewId}/move`,
        body: {
          data: {
            position,
          },
        },
      }),
      transformResponse: (response: IMoveReviewResponse): UnwrapData<IMoveReviewResponse> => response.data,
      invalidatesTags: ['MainPageReviews'],
    }),
  }),
});

export const {
  useGetReviewsQuery,
  useCreateReviewMutation,
  useUpdateReviewMutation,
  useDeleteReviewMutation,
  useMoveReviewMutation,
} = reviewsService;
